module.exports = __webpack_public_path__ + "static/media/kathryn_frederick.1a29d78a.png";